import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin: 2 0;\n  padding: 0;\n\n  a {\n    color: nav-link;\n    display: block;\n    transition: base;\n    transition-property: color;\n    padding-left: 10;\n    border-left: 3;\n    border-color: transparent;\n\n    &:hover {\n      color: nav-link-hover;\n    }\n\n    &.active {\n      font-weight: 600;\n      border-left: 3;\n      border-color: primary;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 17;\n  font-weight: 500;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 20;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-left: 40;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 20;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import staticQueryData from "../../../../public/static/d/3169589528.json";
import React from 'react';
import { StaticQuery, Link } from 'gatsby';
import styled, { css } from '@xstyled/styled-components';
import { up } from '@xstyled/system';
var QUERY = "3169589528";

var createOrFindGroup = function createOrFindGroup(name, groups) {
  var group = groups.find(function (group) {
    return group.name === name;
  });

  if (!group) {
    group = {
      name: name,
      pages: []
    };
    groups.push(group);
  }

  return group;
};

var sortByOrder = function sortByOrder(a, b) {
  var diff = (a.context.frontmatter.order || 0) - (b.context.frontmatter.order || 0);
  return diff === 0 ? 0 : diff > 0 ? 1 : -1;
};

var pagesToNavGroups = function pagesToNavGroups(pages) {
  return pages.reduce(function (groups, page) {
    if (!page.context.frontmatter.menu) {
      return groups;
    }

    var group = createOrFindGroup(page.context.frontmatter.menu, groups);
    group.pages.push(page);
    group.pages.sort(sortByOrder);
    return groups;
  }, []);
};

var Nav = styled.nav(_templateObject(), up('sm', css(_templateObject2())));
var NavGroup = styled.div(_templateObject3());
var NavGroupTitle = styled.h3(_templateObject4());
var NavGroupMenu = styled.ul(_templateObject5());
var NavGroupMenuItem = styled.li(_templateObject6());

var sortGroupsWithConfig = function sortGroupsWithConfig(menu) {
  return function (a, b) {
    var indexA = menu.indexOf(a.name);
    var indexB = menu.indexOf(b.name);
    var diff = indexA - indexB;
    return diff === 0 ? 0 : diff < 0 ? -1 : 1;
  };
};

export function Sidebar() {
  return React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      var navGroups = pagesToNavGroups(data.allSitePage.edges.map(function (edge) {
        return edge.node;
      }).filter(function (node) {
        return node.context && node.context.frontmatter;
      }));
      navGroups.sort(sortGroupsWithConfig(data.site.siteMetadata.menu));
      return React.createElement(Nav, null, navGroups.map(function (navGroup) {
        return React.createElement(NavGroup, {
          key: navGroup.name
        }, React.createElement(NavGroupTitle, null, navGroup.name), React.createElement(NavGroupMenu, null, navGroup.pages.map(function (page) {
          return React.createElement(NavGroupMenuItem, {
            key: page.id
          }, React.createElement(Link, {
            activeClassName: "active",
            to: page.path
          }, page.context.frontmatter.title));
        })));
      }));
    },
    data: staticQueryData
  });
}